import React from 'react';
import { Instagram } from 'lucide-react';
import { Button } from './ui/button';
import { instagramHandle } from '../data/mockData';

// Sample Instagram grid images from Morea Bogotá
const instagramImages = [
  'https://morea-dress-rental1.odoo.com/web/image/38452-dca8f676/Morea00459%201.jpg',
  'https://morea-dress-rental1.odoo.com/web/image/38437-f8381fe2/Morea00584%201.jpg',
  'https://morea-dress-rental1.odoo.com/web/image/38434-fd8fc5a2/Morea00606%201.jpg',
  'https://morea-dress-rental1.odoo.com/web/image/40234-9f806e6b/_JEI0187%201.jpg',
  'https://morea-dress-rental1.odoo.com/web/image/29646-a61ab623/_JEI2724.jpg',
  'https://morea-dress-rental1.odoo.com/web/image/46601-0c6e984a/Morea-2304202300977-scaled.jpeg'
];

const InstagramSection = () => {
  const handleInstagramClick = () => {
    window.open('https://www.instagram.com/morea_dressrental.ec', '_blank');
  };

  return (
    <section id="instagram" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif text-neutral-900 mb-4">Síguenos en Instagram</h2>
          <p className="text-lg text-neutral-600 font-light max-w-2xl mx-auto mb-6">
            Descubre nuevos ingresos, inspiración para eventos y vestidos disponibles en nuestras sedes de Ecuador.
          </p>
          <div className="flex items-center justify-center gap-2 mb-8">
            <Instagram className="w-6 h-6 text-neutral-900" />
            <span className="text-xl font-light text-neutral-900">{instagramHandle}</span>
          </div>
          <Button
            onClick={handleInstagramClick}
            className="bg-neutral-900 hover:bg-neutral-800 text-white px-8 py-6 text-lg rounded-sm transition-all duration-300 hover:shadow-xl hover:scale-105"
          >
            Ver Instagram
          </Button>
        </div>

        {/* Instagram Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-5xl mx-auto">
          {instagramImages.map((image, index) => (
            <div 
              key={index}
              className="aspect-square overflow-hidden cursor-pointer group bg-neutral-100 rounded-sm"
              onClick={handleInstagramClick}
            >
              <img
                src={image}
                alt={`Instagram post ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InstagramSection;
